import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import formula from "../assests/images/calculating (1).png";
import note from "../assests/images/writing.png";
import para from "../assests/images/grammar.png";
import imag from "../assests/images/image.png";

const tools = [
  {
    name: "Solving Questions",
    img: formula,
    desc: "Snap, solve. Math made easy — get clear steps when homework gets stuck.",
    to: "/formula",
    icon: "ri-calculator-line",
  },
  {
    name: "Extract Text from Image",
    img: imag,
    desc: "Upload an image and pull out the text so you can edit, search, or study from it.",
    to: "/extract",
    icon: "ri-image-line",
  },
  {
    name: "Grammar and Spell Check",
    img: para,
    desc: "Paste text or upload an image and get a cleaner, paraphrased version instantly.",
    to: "/paraphrase",
    icon: "ri-quill-pen-line",
  },
  {
    name: "Summary and Note Making",
    img: note,
    desc: "Turn dense pages into concise notes you can actually revise from.",
    to: "/notemaking",
    icon: "ri-file-list-3-line",
  },
];

const Divein = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="relative min-h-[calc(100vh-72px)] overflow-hidden bg-brand-surface">
      <div
        className="pointer-events-none absolute -left-24 top-10 h-72 w-72 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.2),transparent_70%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(10,43,30,0.08),transparent_72%)]"
        aria-hidden="true"
      />

      <section className="relative py-14 md:py-20">
        <Container>
          <div className="mb-10 max-w-[560px] animate-fade-up">
            <p className="section-label">Study toolkit</p>
            <h1 className="mb-3 font-display text-[clamp(2rem,4vw,3rem)] font-extrabold tracking-tight text-brand-forest">
              Choose a tool and dive in
            </h1>
            <p className="m-0 text-[1.05rem] leading-relaxed text-brand-muted">
              Pick what you need right now — math help, notes, grammar, or text from images.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
            {tools.map((tool, index) => (
              <Link
                key={tool.to}
                to={tool.to}
                className={`group flex min-h-full flex-col rounded-[20px] border border-brand-forest/10 bg-white p-6 no-underline transition hover:-translate-y-1 hover:border-brand-teal/40 hover:shadow-brand ${
                  index === 0
                    ? "animate-fade-up-1"
                    : index === 1
                      ? "animate-fade-up-2"
                      : index === 2
                        ? "animate-fade-up-3"
                        : "animate-fade-up-3"
                }`}
              >
                <span className="mb-5 inline-flex h-14 w-14 items-center justify-center rounded-[14px] border border-brand-teal/25 bg-brand-soft">
                  <i className={`${tool.icon} text-[1.5rem] text-brand-teal-dark`} />
                </span>

                <div className="mb-5 flex h-28 items-center justify-center">
                  <img
                    src={tool.img}
                    alt=""
                    className="h-full max-h-28 w-auto object-contain transition duration-300 group-hover:scale-105"
                  />
                </div>

                <h2 className="mb-2 font-display text-xl font-bold text-brand-forest">
                  {tool.name}
                </h2>
                <p className="mb-5 flex-1 text-base leading-relaxed text-brand-muted">
                  {tool.desc}
                </p>
                <span className="inline-flex items-center gap-1 font-display text-[0.92rem] font-semibold text-brand-teal-dark">
                  Open tool
                  <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" />
                </span>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Divein;
